import { Component, inject } from '@angular/core';
import {SubChangeService} from "../../../data/services/sub-change.service";
import {HupSubscriptionsService} from "../../../data/services/hup-subscriptions.service";
import {TranslationService} from "../../../core/services/translation.service";
import {ActivatedRoute} from "@angular/router";
import {NavigationCommand, NavigationService} from "../../../data/services/navigation.service";
import {HupSubscription} from "../../../data/models/subscription.model";
import {BaseDataService} from "../../../core/services/base-data.service";
import {MatButton} from "@angular/material/button";
import { DatePipe } from "@angular/common";
import {LoadingSpinnerComponent} from "../../../core/components/loading-spinner/loading-spinner.component";
import {GeneralErrorsComponent} from "../../../core/components/general-errors/general-errors.component";
import {MatCard, MatCardActions, MatCardContent, MatCardSubtitle, MatCardTitle} from "@angular/material/card";
import {HouseNoPipe} from "../../../core/pipes/houseno.pipe";
import {
  MatAccordion,
  MatExpansionPanel, MatExpansionPanelContent,
  MatExpansionPanelDescription, MatExpansionPanelHeader,
  MatExpansionPanelTitle
} from "@angular/material/expansion";
import {ApplyIfNotEmptyDirective} from "../../../core/directives/apply-if-not-empty.directive";
import {OnlinePaymentChecker} from "../../../core/components/utils/online-payment-checker";
import {ConfigService} from "../../../core/services/config.service";
import {isDigital} from "../../../core/utils/offer-utils";

@Component({
  selector: 'app-sub-change-without-login',
  templateUrl: './sub-change-without-login.component.html',
  styleUrls: ['./sub-change-without-login.component.css'],
  imports: [
    MatButton,
    LoadingSpinnerComponent,
    GeneralErrorsComponent,
    MatCard,
    MatCardTitle,
    MatCardSubtitle,
    DatePipe,
    HouseNoPipe,
    MatCardActions,
    MatCardContent,
    MatAccordion,
    MatExpansionPanel,
    MatExpansionPanelTitle,
    MatExpansionPanelDescription,
    MatExpansionPanelContent,
    MatExpansionPanelHeader,
    ApplyIfNotEmptyDirective
  ],
  providers: [
    DatePipe
  ],
  standalone: true
})
export class SubChangeWithoutLoginComponent {
  private hupSubscriptionsService = inject(HupSubscriptionsService);
  private subChangeService = inject(SubChangeService);
  private baseDataService = inject(BaseDataService);
  translationService = inject(TranslationService);
  private route = inject(ActivatedRoute);
  private navigationService = inject(NavigationService);
  private configService = inject(ConfigService);

  protected onlinePaymentChecker: OnlinePaymentChecker = new OnlinePaymentChecker();

  isLoadingSub: boolean = false;
  subs: HupSubscription[] = [];
  errorsArr: string[] = [];
  identified: boolean = false;
  noOrdersFound: boolean = false;

  constructor() {
    this.route.paramMap.subscribe((params) => {

      const clientNo : number = Number(params.get('clientNo'));
      if(clientNo) {
        this.identified = true;
        this.loadOrdersForClientNo(clientNo);
      }
    });
    const onlinePaymentConfig = this.configService.getConfig(this.onlinePaymentChecker.ONLINE_PAYMENT_METHOD_ID_CONFIG_KEY);
    if (onlinePaymentConfig && onlinePaymentConfig.value) {
      this.onlinePaymentChecker.setPaymentCode(onlinePaymentConfig.value);
    }
  }

  loadOrdersForClientNo(clientNo: number): void {
    this.isLoadingSub = true;
    this.subs = [];
    this.noOrdersFound = false;
    if (clientNo && Number(clientNo) > 0) {
      this.hupSubscriptionsService.getSubscriptionsUnauthorized(clientNo).subscribe(orders => {
        this.isLoadingSub = false;
        if (orders.length === 1 && orders[0]) {
          this.onNewSubChange(orders[0]);
        } else if (orders.length > 1) {
          orders.forEach(order => {
            if(
              (order.validDate.validUntil == null || order.validDate.validUntil > new Date())
              && order.backendId > 0
              && (!isDigital(order.offer?.offerType) && !isDigital(order.subscriptionType))
            ) {
              this.baseDataService.handleUnauthorizedOrder(order);
              if (!order.variantDescription) {
                this.baseDataService.loadBaseData('variantcode').subscribe(
                  (bds) => {
                    bds?.forEach(bd => {
                      if (bd.key === order.variantCode) {
                        order.variantDescription = bd.description;
                      }
                    })
                  }
                );
              }
              this.subs.push(order);
            }
          });

          this.subs.forEach(sub => {
            sub.isLoadingSubChange = true;

            this.subChangeService.getSubChanges(sub.backendId, sub.userBackendId).subscribe({
              next: (res) => {
                sub.subChanges = res;
              },
              error: (error) => {
                sub.isLoadingSubChange = false;
                this.errorsArr.push(this.translationService.getTranslation('error_subchanges_init'));
              },
              complete: () => {
                sub.isLoadingSubChange = false;
              }
            });
          });
        } else {
          this.noOrdersFound = true;
        }
      });
    }
  }

  public navigateToIdentification(): void {
    this.navigationService.navigateTo(NavigationCommand.IDENTIFICATION, [NavigationCommand.SUBCHANGE.substring(1)]);
  }

  onNewSubChange(subscription: HupSubscription): void {
    this.navigationService.navigateTo(NavigationCommand.SUBCHANGEWITHOUTLOGINNEW, [subscription.backendId + '', subscription.userBackendId + '', 'true', subscription.productCode, subscription.variantCode]);
  }

  isOnlinePayment(subscription: HupSubscription): boolean {
    return this.onlinePaymentChecker.isOnlinePayment(subscription.curPayment);
  }
}
